import { $api } from 'modules/global';

export const getDirectionByName = (directionName?: string | string[]) => async () => {
  const { data } = await $api.get('/university-info', {
    params: { direction_name: directionName }
  });

  return data;
};
